import "./skip-link-focus-fix";
import AOS from "aos";
import "script-loader!lity";
import "script-loader!slick-carousel";

(function ($) {
  AOS.init({ once: true, duration: 500, easing: "ease-out" });

  $(document).ready(function () {
    menuToggle();
    accordionShortcode();
    languageToggle();
    hotspotMap();
    fullWidthVideo();
    threeColumnTextLinkAccordion();
    fourColumnAccordion();
    photoGallerySlider();
    translationMod();
    translationModCareers();
    translationModCareerPages();
  });

  // Stop translation of WP Jobs Manager pages
  function translationModCareerPages() {
    const findJobBlock = document.querySelector("article.job_listing");
    if (findJobBlock) {
      const mainContent = document.querySelector("#main");
      mainContent.classList.add("notranslate");
    }
  }

  // Stop translation of careers page
  function translationModCareers() {
    const careerPageDetect = document.querySelector(".page-id-1507");
    const recBlock = document.querySelectorAll(
      ".page-id-1507 .resources-block"
    );
    const cardBlock = document.querySelector(".page-id-1507 .full-card");
    const vidBlock = document.querySelector(".page-id-1507 .full-video");
    if (careerPageDetect) {
      for (let i of recBlock) {
        i.classList.add("notranslate");
      }
      cardBlock.classList.add("notranslate");
      vidBlock.classList.add("notranslate");
    }
  }

  // Stop tech names from getting translated
  function translationMod() {
    const menuGrab = document.querySelector("#menu-item-146 .sub-menu");
    menuGrab.classList.add("notranslate");
  }

  // Header menu toggle
  function menuToggle() {
    $("#menu-toggle").on("click", function () {
      $(this).toggleClass("site-header__menu-toggle--open");
      $("#menu-primary-menu").toggleClass("site-header__menu--open");
    });

    $(".submenu-toggle").on("click", function () {
      var submenu = $(this).next(".sub-menu");
      $(this).toggleClass("submenu-toggle--open");
      submenu.slideToggle();
    });
  }

  // Header language toggle
  function languageToggle() {
    $("#language-toggle").on("click", function () {
      $("#language-dropdown").slideToggle(200);
      $(this).toggleClass("site-header__language-toggle--open");
    });
  }

  // Accordion shortcode
  function accordionShortcode() {
    $(".accordion-shortcode__toggle").on("click", function () {
      var accordion = $(this).parent(".accordion-shortcode"),
        content = $(this).prev(".accordion-shortcode__content");

      content.slideToggle();
      accordion.toggleClass("accordion-shortcode--open");
    });

    $(".accordion-shortcode__toggle-readmore").on("click", function () {
      var accordion = $(this).parent(".accordion-shortcode"),
        content = $(this).prev(".accordion-shortcode__content");

      if (accordion.hasClass("accordion-shortcode--open")) {
        $(this).text("Read More");
      } else {
        $(this).text("Close");
      }

      content.slideToggle();
      accordion.toggleClass("accordion-shortcode--open");
    });
  }

  // 3 column text or link block accordion
  function threeColumnTextLinkAccordion() {
    $(".three-link__accordion-toggle").on("click", function () {
      var content = $(this)
        .closest(".three-link__heading-wrap")
        .next(".three-link__accordion-content");

      content.slideToggle();
      $(this).toggleClass("three-link__accordion-toggle--open");
    });
  }

  // Hotspot map block
  function hotspotMap() {
    const hotspotImg = document.querySelector(".hotspot-map__image-wrap img");
    let hotspotImgMarkers = document.querySelector(
      ".hotspot-map__image-markers"
    );
    if (hotspotImgMarkers)
      hotspotImgMarkers.style.width = hotspotImg.width + "px";

    const checkTextWidths = document.querySelectorAll(
      ".hotspot-map__image-marker-text"
    );
    checkTextWidths.forEach((i) => {
      if (i.innerText.length > 1) i.style.left = "6px";
    });

    $(".hotspot-map__image-marker").on("click", function (e) {
      e.preventDefault();
      let clickID = this.id;
      clickID = clickID.split("-");
      clickID = clickID[1];

      let hotspotPopUps = document.querySelectorAll(
        ".hotspot-map__marker-popup"
      );

      for (let i of hotspotPopUps) {
        let targetID = i.id;
        targetID = targetID.split("-");
        targetID = targetID[1];
        if (targetID == clickID) {
          i.classList.add("hotspot-map__marker-popup--open");
        } else {
          i.classList.remove("hotspot-map__marker-popup--open");
        }
      }
    });

    $(".hotspot-map__image-marker-text").on("click", function (e) {
      e.preventDefault();

      var popup = $(this).next(".hotspot-map__marker-popup");

      popup.toggleClass("hotspot-map__marker-popup--open");

      $(".hotspot-map__marker-popup")
        .not(popup)
        .removeClass("hotspot-map__marker-popup--open");
    });

    $(".hotspot-map__popup-close").on("click", function (e) {
      e.preventDefault();

      var popup = $(this).closest(".hotspot-map__marker-popup");

      popup.toggleClass("hotspot-map__marker-popup--open");
    });

    $(document).on("click", function (e) {
      if (
        !$(".hotspot-map__marker-popup").is(e.target) &&
        !$(".hotspot-map__image-marker").is(e.target) &&
        !$(".hotspot-map__image-marker-text").is(e.target) &&
        $(".hotspot-map__marker-popup").has(e.target).length === 0
      ) {
        $(".hotspot-map__marker-popup").removeClass(
          "hotspot-map__marker-popup--open"
        );
      }
    });

    /* $(".hotspot-map__popup-videotoggle").on("click", function () {
      var video = $(this).next(".hotspot-map__popup-video");

      $(this).hide();
      video.show();
      video[0].play();
    }); */
  }

  // Full width video
  function fullWidthVideo() {
    $(".full-video__play").on("click", function () {
      var video = $(this).next(".full-video__video"),
        src = video.data("src");

      video.attr("src", src);
      video.show();
    });
  }

  // 4 column accordion
  function fourColumnAccordion() {
    $(".four-accordion__accordion").on({
      mouseenter: function () {
        $(this).addClass("four-accordion__accordion--open");

        $(".four-accordion__wrap").addClass("four-accordion__wrap--open");
      },
      mouseleave: function () {
        var accordions = $(this)
          .closest(".four-accordion__wrap")
          .children(".four-accordion__accordion");

        $(".four-accordion__wrap").removeClass("four-accordion__wrap--open");

        accordions.removeClass("four-accordion__accordion--open");
      },
    });
  }

  // Photo gallery block slider
  function photoGallerySlider() {
    var slider = $("#photo-gallery"),
      sliderNav = $("#photo-gallery-nav");

    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 4000,
      adaptiveHeight: true,
    });

    sliderNav.slick({
      slidesToShow: 9,
      slidesToScroll: 1,
      asNavFor: "#photo-gallery",
      focusOnSelect: true,
      arrows: false,
      draggable: false,
    });

    slider.on("afterChange", function (event, slick, currentSlide) {
      sliderNav.slick("slickGoTo", currentSlide);
      var currrentNavSlideElem = sliderNav.find(
        '.slick-slide[data-slick-index="' + currentSlide + '"]'
      );
      sliderNav.find(".slick-slide.is-active").removeClass("is-active");
      $(currrentNavSlideElem).addClass("is-active");
    });

    $("#photo-gallery-next").on("click", function () {
      slider.slick("slickNext");
    });

    $("#photo-gallery-previous").on("click", function () {
      slider.slick("slickPrev");
    });
  }
})(jQuery);
